const inspectorKPIs = [
    {
        'uuid': '1',
        'inspector': '王大同',
        'inspectorRole': '主導稽核員',
        "appQuantity": 10,
        'manDays': 5,
        'qualityComplianceRate': 50,
        'timeComplianceRate': 50,
        'adviceForInspector': 'A21122101B查驗項次2.5項引用條文應為GHP 附表二1',
    },
    {
        'uuid': '2',
        'inspector': '王大同',
        'inspectorRole': '稽核員',
        "appQuantity": 4,
        'manDays': 2,
        'qualityComplianceRate': 0,
        'timeComplianceRate': 100,
        'adviceForInspector': '',
    },
    {
        'uuid': '3',
        'inspector': '林小華',
        'inspectorRole': '主導稽核員',
        "appQuantity": 4,
        'manDays': 2,
        'qualityComplianceRate': 0,
        'timeComplianceRate': 100,
        'adviceForInspector': '',
    },
    {
        'uuid': '4',
        'inspector': '林小華',
        'inspectorRole': '稽核員',
        "appQuantity": 6,
        'manDays': 3,
        'qualityComplianceRate': 0,
        'timeComplianceRate': 0,
        'adviceForInspector': '',
    },
    {
        'uuid': '5',
        'inspector': '吳小花',
        'inspectorRole': '稽核員',
        "appQuantity": 10,
        'manDays': 5,
        'qualityComplianceRate': 0,
        'timeComplianceRate': 50,
        'adviceForInspector': '',
    },
]

export default inspectorKPIs;